import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import { getLoginInform } from 'function/login';
import { ROUTER_PATH } from 'types/const';
import { RETURN_YN } from 'types/type';
import format from 'utils/string/format';

import AuthLayout from 'layouts/AuthLayout';

import MyPage from 'components/pages/haccp/MyPage';

/* 모니터링*/
import MonitoringIcheon from 'components/pages/haccp/monitoring/icheon/View';
import MonitoringGunsan from 'components/pages/haccp/monitoring/gunsan/View';
import ProductionResultList from 'components/pages/haccp/monitoring/common/page/production/productionResult/List';
import ProductionResultDetail from 'components/pages/haccp/monitoring/common/page/production/productionResult/Detail';
import RawMaterialResultList from 'components/pages/haccp/monitoring/common/page/rawMaterial/rawMaterialResult/List';
import RawMaterialResultDetail from 'components/pages/haccp/monitoring/common/page/rawMaterial/rawMaterialResult/Detail';
import ProcessResultList from 'components/pages/haccp/monitoring/common/page/process/result/List';
import ProcessResultDetail from 'components/pages/haccp/monitoring/common/page/process/result/Detail';
import LimitStandardList from 'components/pages/haccp/monitoring/common/page/limitStandard/List';
import LimitStandardDetail from 'components/pages/haccp/monitoring/common/page/limitStandard/Detail';
import ProductionCcpList from 'components/pages/haccp/monitoring/common/page/production/ccpManagement/List';
import ProductionCcpDetail from 'components/pages/haccp/monitoring/common/page/production/ccpManagement/Detail';
import RawMaterialCcpList from 'components/pages/haccp/monitoring/common/page/rawMaterial/ccpManagement/List';
import RawMaterialCcpDetail from 'components/pages/haccp/monitoring/common/page/rawMaterial/ccpManagement/Detail';
import ProductionTodoList from 'components/pages/haccp/monitoring/common/page/production/todo/List';
import ProductionTodoDetail from 'components/pages/haccp/monitoring/common/page/production/todo/Detail';
import RawMaterialTodoList from 'components/pages/haccp/monitoring/common/page/rawMaterial/todo/List';
import RawMaterialTodoDetail from 'components/pages/haccp/monitoring/common/page/rawMaterial/todo/Detail';
import UnrequestedHistoryList from 'components/pages/haccp/monitoring/common/page/production/unrequestedHistory/List';
import UnrequestedHistoryDetail from 'components/pages/haccp/monitoring/common/page/production/unrequestedHistory/Detail';

/* 검사결과 */
import SampleResultList from 'components/pages/haccp/result/sampleResult/List';
import SampleResultDetail from 'components/pages/haccp/result/sampleResult/Detail';
import IngredientResultList from 'components/pages/haccp/result/ingredientResult/List';
import IngredientResultDetail from 'components/pages/haccp/result/ingredientResult/Detail';
import ProteinResultList from 'components/pages/haccp/result/proteinResult/List';
import ProteinResultDetail from 'components/pages/haccp/result/proteinResult/Detail';
import HygieneResultList from 'components/pages/haccp/result/hygieneResult/List';
import HygieneResultDetail from 'components/pages/haccp/result/hygieneResult/Detail';

/* 모선정보 */
import MotherShipList from 'components/pages/haccp/mothershipInfo/List';
import MotherShipDetail from 'components/pages/haccp/mothershipInfo/Detail';

/* 리포트 */
import MonthEndReportList from 'components/pages/haccp/report/monthEndReport/List';
import MonthEndReportDetail from 'components/pages/haccp/report/monthEndReport/Detail';
import rawMaterialReportList from 'components/pages/haccp/report/rawMaterial/List';
import limitStandardReport from 'components/pages/haccp/report/limitStandard/List';
import regularReviewReport from 'components/pages/haccp/report/regularReview/List';

/* 검사기준정보 */
import InspectionSettingList from 'components/pages/haccp/inspStandardInfo/ingredientsMgmt/List';
import InspectionSettingDetail from 'components/pages/haccp/inspStandardInfo/ingredientsMgmt/Detail';
import InspectionTypeList from 'components/pages/haccp/inspStandardInfo/typeMgmt/List';
import InspectionTypeDetail from 'components/pages/haccp/inspStandardInfo/typeMgmt/Detail';
import InspectionGroupList from 'components/pages/haccp/inspStandardInfo/ingredientsGroup/List';
import InspectionGroupDetail from 'components/pages/haccp/inspStandardInfo/ingredientsGroup/Detail';
import InspectionInfoList from 'components/pages/haccp/inspStandardInfo/standardInfoMgmt/List';
import InspectionInfoDetail from 'components/pages/haccp/inspStandardInfo/standardInfoMgmt/Detail';

/* 기준정보 */
import StandardCode from 'components/pages/standard/code/List';
import ingredientList from 'components/pages/haccp/standardInfo/ingredients/List';
import ingredientDetail from 'components/pages/haccp/standardInfo/ingredients/Detail';
import StandardProcessList from 'components/pages/haccp/standardInfo/processInfo/List';
import SetStandardProcess from 'components/pages/haccp/standardInfo/processInfo/Detail';
import employeeList from 'components/pages/haccp/standardInfo/employee/List';
import employeeDetail from 'components/pages/haccp/standardInfo/employee/Detail';
import productionInfoList from 'components/pages/haccp/standardInfo/productionInfo/List';
import rawMaterialInfoList from 'components/pages/haccp/standardInfo/rawMaterialInfo/List';

/**
 * SFSH 라우터
 */
const SFSHRoutes = () => {
  const { adminYn, fatoryCodeSeq } = getLoginInform();

  return (
    <Switch>
      {/* 로그인 */}
      <Route path={ROUTER_PATH.login} exact component={AuthLayout} />
      {/* 마이 페이지 */}
      <Route path={ROUTER_PATH.myPage} exact component={MyPage} />
      {/* 모니터링 - 이천 */}
      {(adminYn === RETURN_YN.Y || fatoryCodeSeq === 1) && (
        <Route
          path={ROUTER_PATH.sfsh.monitoring.icheon.view}
          exact
          component={MonitoringIcheon}
        />
      )}
      {/* 모니터링 - 군산 */}
      {(adminYn === RETURN_YN.Y || fatoryCodeSeq === 2) && (
        <Route
          path={ROUTER_PATH.sfsh.monitoring.gunsan.view}
          exact
          component={MonitoringGunsan}
        />
      )}
      {/* 제품결과 */}
      <Route
        path={ROUTER_PATH.sfsh.monitoring.productionResult.list}
        exact
        component={ProductionResultList}
      />
      <Route
        path={format(ROUTER_PATH.sfsh.monitoring.productionResult.detail, {
          seq: ':seq?'
        })}
        exact
        component={ProductionResultDetail}
      />
      {/* 원료결과 */}
      <Route
        path={ROUTER_PATH.sfsh.monitoring.rawMaterialResult.list}
        exact
        component={RawMaterialResultList}
      />
      <Route
        path={format(ROUTER_PATH.sfsh.monitoring.rawMaterialResult.detail, {
          seq: ':seq?'
        })}
        exact
        component={RawMaterialResultDetail}
      />
      {/* 공정결과 */}
      <Route
        path={ROUTER_PATH.sfsh.monitoring.processResult.list}
        exact
        component={ProcessResultList}
      />
      <Route
        path={format(ROUTER_PATH.sfsh.monitoring.processResult.detail, {
          seq: ':seq?'
        })}
        exact
        component={ProcessResultDetail}
      />
      {/* 한계기준이탈 */}
      <Route
        path={ROUTER_PATH.sfsh.monitoring.criticalLimit.list}
        exact
        component={LimitStandardList}
      />
      <Route
        path={format(ROUTER_PATH.sfsh.monitoring.criticalLimit.detail, {
          seq: ':seq?'
        })}
        exact
        component={LimitStandardDetail}
      />
      {/* 제품 - CCP관리 */}
      <Route
        path={ROUTER_PATH.sfsh.monitoring.productionCcpMgmt.list}
        exact
        component={ProductionCcpList}
      />
      <Route
        path={format(ROUTER_PATH.sfsh.monitoring.productionCcpMgmt.detail, {
          seq: ':seq?'
        })}
        exact
        component={ProductionCcpDetail}
      />
      {/* 원료 - CCP관리 */}
      <Route
        path={ROUTER_PATH.sfsh.monitoring.rawMaterialCcpMgmt.list}
        exact
        component={RawMaterialCcpList}
      />
      <Route
        path={format(ROUTER_PATH.sfsh.monitoring.rawMaterialCcpMgmt.detail, {
          seq: ':seq?'
        })}
        exact
        component={RawMaterialCcpDetail}
      />
      {/* 제품 - 할일 */}
      <Route
        path={ROUTER_PATH.sfsh.monitoring.productionTodo.list}
        exact
        component={ProductionTodoList}
      />
      <Route
        path={format(ROUTER_PATH.sfsh.monitoring.productionTodo.detail, {
          seq: ':seq?'
        })}
        exact
        component={ProductionTodoDetail}
      />
      {/* 원료 - 할일 */}
      <Route
        path={ROUTER_PATH.sfsh.monitoring.rawMaterialTodo.list}
        exact
        component={RawMaterialTodoList}
      />
      <Route
        path={format(ROUTER_PATH.sfsh.monitoring.rawMaterialTodo.detail, {
          seq: ':seq?'
        })}
        exact
        component={RawMaterialTodoDetail}
      />
      {/* 미의뢰내역 */}
      <Route
        path={ROUTER_PATH.sfsh.monitoring.unRequested.list}
        exact
        component={UnrequestedHistoryList}
      />
      <Route
        path={format(ROUTER_PATH.sfsh.monitoring.unRequested.detail, {
          seq: ':seq?'
        })}
        exact
        component={UnrequestedHistoryDetail}
      />

      {/* -------검사결과------- */}

      {/* 시료분석 결과 */}
      <Route
        path={ROUTER_PATH.sfsh.inspectResult.sample.list}
        exact
        component={SampleResultList}
      />
      <Route
        path={format(ROUTER_PATH.sfsh.inspectResult.sample.detail, {
          seq: ':seq?'
        })}
        exact
        component={SampleResultDetail}
      />
      {/* 성분분석 결과 */}
      <Route
        path={ROUTER_PATH.sfsh.inspectResult.ingredient.list}
        exact
        component={IngredientResultList}
      />
      <Route
        path={format(ROUTER_PATH.sfsh.inspectResult.ingredient.detail, {
          seq: ':seq?'
        })}
        exact
        component={IngredientResultDetail}
      />
      {/* 동물성단백질 결과 */}
      <Route
        path={ROUTER_PATH.sfsh.inspectResult.protein.list}
        exact
        component={ProteinResultList}
      />
      <Route
        path={format(ROUTER_PATH.sfsh.inspectResult.protein.detail, {
          seq: ':seq?'
        })}
        exact
        component={ProteinResultDetail}
      />
      {/* 위생검사 결과 */}
      <Route
        path={ROUTER_PATH.sfsh.inspectResult.hygiene.list}
        exact
        component={HygieneResultList}
      />
      <Route
        path={format(ROUTER_PATH.sfsh.inspectResult.hygiene.detail, {
          seq: ':seq?'
        })}
        exact
        component={HygieneResultDetail}
      />
      {/* 모선정보 */}
      <Route
        path={ROUTER_PATH.sfsh.motherShip.list}
        exact
        component={MotherShipList}
      />
      <Route
        path={format(ROUTER_PATH.sfsh.motherShip.detail, {
          seq: ':seq?'
        })}
        exact
        component={MotherShipDetail}
      />
      {/*------- REPORT -------*/}
      {/* 월말보고서 */}
      <Route
        path={ROUTER_PATH.sfsh.report.monthEndReport.list}
        exact
        component={MonthEndReportList}
      />
      <Route
        path={format(ROUTER_PATH.sfsh.report.monthEndReport.detail, {
          seq: ':seq?'
        })}
        exact
        component={MonthEndReportDetail}
      />
      {/* 주요원료도입현황 */}
      <Route
        path={ROUTER_PATH.sfsh.report.rawMaterial.list}
        exact
        component={rawMaterialReportList}
      />
      {/* 한계기준 이탈현황 */}
      <Route
        path={ROUTER_PATH.sfsh.report.limitStandard.list}
        exact
        component={limitStandardReport}
      />
      {/* 정기심사브리핑 */}
      <Route
        path={ROUTER_PATH.sfsh.report.regularReview.list}
        exact
        component={regularReviewReport}
      />

      {/* -------검사기준정보------- */}
      {/* 검사성분 관리 */}
      <Route
        path={ROUTER_PATH.sfsh.inspection.inspectionSetting.list}
        exact
        component={InspectionSettingList}
      />
      <Route
        path={format(ROUTER_PATH.sfsh.inspection.inspectionSetting.setting, {
          seq: ':seq?'
        })}
        exact
        component={InspectionSettingDetail}
      />
      {/* 검사종류 관리 */}
      <Route
        path={ROUTER_PATH.sfsh.inspection.inspectionType.list}
        exact
        component={InspectionTypeList}
      />
      <Route
        path={format(ROUTER_PATH.sfsh.inspection.inspectionType.setting, {
          seq: ':seq?'
        })}
        exact
        component={InspectionTypeDetail}
      />
      {/* 시료기준 관리 */}
      <Route
        path={ROUTER_PATH.sfsh.inspection.inspectionGroup.list}
        exact
        component={InspectionGroupList}
      />
      <Route
        path={format(ROUTER_PATH.sfsh.inspection.inspectionGroup.setting, {
          seq: ':seq?'
        })}
        exact
        component={InspectionGroupDetail}
      />
      {/* 시료정보 관리*/}
      <Route
        path={ROUTER_PATH.sfsh.inspection.inspectionInfo.list}
        exact
        component={InspectionInfoList}
      />
      <Route
        path={format(ROUTER_PATH.sfsh.inspection.inspectionInfo.setting, {
          seq: ':seq?'
        })}
        exact
        component={InspectionInfoDetail}
      />
      {/* -------기준정보------- */}

      {/* 등록성분량관리 */}
      <Route
        path={ROUTER_PATH.sfsh.standard.ingredient.list}
        exact
        component={ingredientList}
      />
      <Route
        path={format(ROUTER_PATH.sfsh.standard.ingredient.setting, {
          seq: ':seq?'
        })}
        exact
        component={ingredientDetail}
      />
      {/* 공장검사의뢰코드 */}
      <Route
        path={ROUTER_PATH.sfsh.standard.process.list}
        exact
        component={StandardProcessList}
      />
      <Route
        path={format(ROUTER_PATH.sfsh.standard.process.setting, {
          seq: ':seq?'
        })}
        exact
        component={SetStandardProcess}
      />
      {/* 제품정보 */}
      <Route
        path={ROUTER_PATH.sfsh.standard.productionInfo.list}
        exact
        component={productionInfoList}
      />
      {/* 원료정보 */}
      <Route
        path={ROUTER_PATH.sfsh.standard.rawMaterialInfo.list}
        exact
        component={rawMaterialInfoList}
      />
      {/* 속성코드관리 */}
      {adminYn === RETURN_YN.Y && (
        <Route
          path={ROUTER_PATH.standard.code.default}
          exact
          component={StandardCode}
        />
      )}
      {/* 사원관리 */}
      {adminYn === RETURN_YN.Y && (
        <Route
          path={ROUTER_PATH.sfsh.standard.employee.list}
          exact
          component={employeeList}
        />
      )}
      {adminYn === RETURN_YN.Y && (
        <Route
          path={format(ROUTER_PATH.sfsh.standard.employee.setting, {
            seq: ':seq?'
          })}
          exact
          component={employeeDetail}
        />
      )}

      {/* Redirect */}
      <Redirect to="/errors/404" />
    </Switch>
  );
};

export default SFSHRoutes;
